import React from "react";
import Faq from "../components/Faq";

const FaqSection = ({ fields }) => {
    if (!fields) return null;
    return <Faq data={fields} />;
};

export default FaqSection;

